import { createAction } from "redux-act";
import { schema } from "normalizr";
import { createAsyncAction, request } from "../lib/utils";

const offer = new schema.Entity("offers", {}, { idAttribute: "uid" });

export const setSortAction = createAction("setSortAction");
export const setSort = (
  { sortField, sortDir },
  view = "default"
) => async dispatch => {
  dispatch(setSortAction({ sortField, sortDir, view }));
  dispatch(setPage({ page: 1 }));
  dispatch(getAll());
};

export const setPageAction = createAction("setPageAction");
export const setPage = ({ page }, view = "default") => async dispatch => {
  dispatch(setPageAction({ page, view }));
  dispatch(getAll({}, view));
};

export const getAllAction = createAsyncAction("getAll");
export const getAll = (data = {}, view = "default") => async (
  dispatch,
  getState
) => {
  return request(
    "get",
    "/v1/offers",
    {
      params: getState()
        .offers.params.get(view)
        .toJS()
    },
    { view, action: getAllAction, schema: { offers: [offer] }, dispatch }
  );
};

export const getAction = createAsyncAction("get");
export const get = (uid, view = "default") => async (dispatch, getState) => {
  return request("get", `/v1/offers/${uid}`, null, {
    view,
    action: getAction,
    schema: offer,
    dispatch
  });
};

export const createOfferAction = createAsyncAction("createOffer");
export const createOffer = data => async (dispatch, getState) => {
  return request(
    "post",
    "/v1/offers",
    {
      data
    },
    { action: createOfferAction, dispatch }
  );
};

export const updateOfferAction = createAsyncAction("updateOffer");
export const updateOffer = (data, uid) => async (dispatch, getState) => {
  return request(
    "patch",
    `/v1/offers/${uid}`,
    {
      data
    },
    { action: updateOfferAction, dispatch }
  );
};



// WEBPACK FOOTER //
// ./src/offers/actions.js